import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['Chcesz gotowych zajęć bez godzin planowania', 'Twoje dziecko ciągle pyta „dlaczego?” i uwielbia robić coś własnymi rękami', 'Chcesz mniej biernego patrzenia w ekran, a więcej prawdziwej kreatywności', 'Przed startem chcesz wiedzieć, jakie materiały, ile czasu i ile Twojej pomocy będzie potrzebne', 'Szukasz projektów, które bawią, bo dziecko naprawdę coś robi'];
const notForYou = ['Szukasz fizycznego zestawu STEM wysyłanego pocztą', 'Chcesz zaawansowanej robotyki, programowania albo pełnego kursu wideo', 'Szukasz tylko kart pracy do wypełniania albo filmików do oglądania', 'Nie chcesz korzystać z prostych rzeczy z domu i z recyklingu'];
export function AudienceSection() {
  return <section className="w-full bg-background px-5 py-12 sm:py-20" data-id="element-10" data-mp="3cq0sc12ibfpm">
      <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2" data-id="element-11" data-mp="3hpdbaaq9c2mx">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border border-primary/15 bg-secondary p-6 sm:p-8" data-id="element-12" data-mp="3hnk5syrdrogi">
          <h3 className="mb-6 text-lg font-bold text-primary-strong sm:text-xl" data-id="element-13" data-mp="uiwmuf94nhl5">
            ✓ To dla Ciebie, jeśli…
          </h3>
          <ul className="space-y-4" data-id="element-14" data-mp="lk1eoxmivxf7">
            {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-15" data-mp="lhyjlz6ije3m">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success/15 text-success" data-id="element-16" data-mp="gjn8ll4hexjt">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-17" data-mp="bnyevyf58avf" />
                </span>
                <span className="text-sm leading-relaxed text-foreground/80" data-id="element-18" data-mp="7mwgtkwyq4v1">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="rounded-2xl border border-accent/20 bg-accent-soft p-6 sm:p-8" data-id="element-19" data-mp="21zw1vtk43r9p">
          <h3 className="mb-6 text-lg font-bold text-foreground sm:text-xl" data-id="element-20" data-mp="3mhwp7hxvsfxs">✕ To nie dla Ciebie, jeśli…</h3>
          <ul className="space-y-4" data-id="element-21" data-mp="3qiqdicf8jwr7">
            {notForYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-22" data-mp="i3gitpdodttg">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent/15 text-accent-strong" data-id="element-23" data-mp="n189yh6hxbwl">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-24" data-mp="90xfz59w3h77" />
                </span>
                <span className="text-sm leading-relaxed text-foreground/80" data-id="element-25" data-mp="dzqwz7odxqc4">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}